import config from '../../config.js'
import router from '../../routes'
import * as admins from './admins.json'
import AWS from 'aws-sdk'
import Vue from 'vue'

AWS.config.update({
  region: 'us-east-1',
  credentials: new AWS.Credentials(config.poolData.accessKeyId, config.poolData.secretAccessKey)
})

const cognitoServiceProvider = new AWS.CognitoIdentityServiceProvider()

var AmazonCognitoIdentity = require('amazon-cognito-identity-js')

const state = {
  userPool: new AmazonCognitoIdentity.CognitoUserPool(config.poolData),
  authDetails: '',
  userType: 'trial', // paid user or trial user.
  userData: '',
  cognitoUser: null,
  tokens: {
    accessToken: '',
    idToken: '',
    refreshToken: ''
  },
  username: '',
  errcode: '',
  attributes: [],
  users: [],
  admins
}

const getters = {
  getStateAttributes (state) {
    return state.attributes
  },
  getUsers (state) {
    return state.users
  },
  getUsername (state) {
    return state.username
  },
  getAuthenticated (state) {
    // console.log(state.userPool)
    // if (state.userPool === null || state.userPool === undefined) return false
    // let hasUserPoolId = state.userPool.hasOwnProperty('userPoolId')
    // let idTokenExpired = AWS.config.credentials.needsRefresh()
    // console.log()
    let isSessionExpired = AWS.config.credentials.expired
    console.log(`Session expired?: ${isSessionExpired}`)
    return !isSessionExpired
    // let session = AWS.config.getSession()
    // return !(session === null || session === undefined)

    // console.log(`DEBUG: Id token expired? ${idTokenExpired}`)
    // console.log(`DEBUG: User pool empty?: ${hasUserPoolId}`)
    // return (!idTokenExpired) && hasUserPoolId
  },
  getAdmins (state) {
    return state.admins
  },
  getUserType (state) {
    return state.userType
  }
}

const mutations = {
  signOut (state) {
    state.cognitoUser.signOut()
    state.sessionToken = null
    state.username = ''
    state.userPool = []
    localStorage.clear()
  },
  setAttributes (state, attributes) {
    // console.log('User attributes: ')
    // console.log(attributes)
    state.attributes = attributes
    state.username = state.attributes.filter(function (Obj) {
      return Obj.Name === 'email'
    })[0].Value
    state.userType = state.attributes.filter(function (Obj) {
      return Obj.Name === 'profile'
    })[0].Value
  },
  setUsername (state, payload) {
    state.username = payload
  },
  signIn (state) {
    state.authenticated = true
  },
  setUserPool (state) {
    state.userPool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData)
  },
  setTokens (state, payload) {
    // console.log(payload)
    state.tokens.accessToken = payload.getAccessToken().getJwtToken()
    state.tokens.idToken = payload.getIdToken().getJwtToken()
    state.tokens.refreshToken = payload.getRefreshToken().getToken()
  },
  setCognitoUser (state, payload) {
    state.cognitoUser = payload
  },
  setCognitoDetails (state, authData) {
    state.authDetails = new AmazonCognitoIdentity.AuthenticationDetails(authData)
    state.userData = { Username: authData.Username, Pool: state.userPool }
    state.cognitoUser = new AmazonCognitoIdentity.CognitoUser(state.userData)
  },
  setError (state, payload) {
    state.errcode = payload
  },
  clearError (state) {
    state.errcode = ''
  },
  setUsers: (state, users) => {
    for (let i = 0; i < users.length; i++) {
      Vue.set(state.users, i, users[i])
    }
    // console.log('Users updated.')
    // console.log(state.users)
    // Vue.set(state.users, users)
    // state.users = users
  }
}

const actions = {
  signIn ({ state, commit, dispatch }, authData) {
    commit('clearError')
    commit('setUserPool')
    commit('setCognitoDetails', authData)
    state.cognitoUser.authenticateUser(state.authDetails, {
      onSuccess: (result) => {
        // console.log('sign in success')
        commit('setTokens', result)
        commit('signIn')
        // localStorage.setItem('authenticated', true)
        router.push('/home')
        dispatch('getUserAttributes')
        dispatch('setLogoutTimer', 3600)
      },
      onFailure: (err) => {
        // console.log('sign in failure')
        commit('setError', JSON.stringify(err.code))
      }
    })
  },
  tryAutoSignIn ({ state, commit, dispatch }) {
    commit('setUserPool')
    let cognitoUser = state.userPool.getCurrentUser()
    if (cognitoUser != null) {
      commit('setCognitoUser', cognitoUser)
      state.cognitoUser.getSession(function (err, session) {
        if (err) {
          console.error(JSON.stringify(err))
        } else {
          commit('setTokens', session)
          commit('signIn')
          dispatch('getUserAttributes')
          dispatch('setLogoutTimer', 3600)
        }
      })
    }
  },
  getUserAttributes ({ commit, dispatch }) {
    state.cognitoUser.getUserAttributes(function (err, attributes) {
      if (err) {
        console.error(JSON.stringify(err))
      } else {
        commit('setAttributes', attributes)
      }
    })
  },
  setLogoutTimer ({ state, commit, dispatch }, expirationTime) {
    setTimeout(() => {
      dispatch('signOut')
    }, expirationTime * 1000)
  },
  signOut ({ commit }) {
    commit('signOut')
    // localStorage.setItem('authenticated', false)
    // router.push('/home')
  },
  fetchUsersFromCognito: (context) => {
    var params = {
      UserPoolId: config.poolData.UserPoolId, /* required */
      AttributesToGet: [
        'email',
        'profile',
        'custom:cases'
      ]
    }
    context.rootState.pblmed.loading = true
    // console.log(AWS)
    cognitoServiceProvider.listUsers(params, function (err, data) {
      if (err) console.error(err, err.stack)
      else {
        const usersRaw = data.Users
        const users = []
        usersRaw.forEach(u => {
          let user = {}
          for (const [k, v] of Object.entries(u)) {
            if (k === 'Attributes') {
              // let attribs = {}
              v.forEach(ua => {
                let uk = ua['Name']
                const uv = ua['Value']
                if (uk === 'custom:cases') uk = 'Cases'
                user[`${uk}`] = uv
              })
              // user[`${k}`] = attribs
            } else {
              user[`${k}`] = v
            }
          }
          users.push(user)
        })
        // console.log(JSON.stringify(users, null, 2))
        context.commit('setUsers', users)
      }
      context.rootState.pblmed.loading = false
    })
  },
  disableUser: (context, uid) => {
    // don't delete yourself.
    if (uid === context.state.username) {
      console.log('You cannot disable yourself.')
      return
    }
    // check that i'm an admin.
    // console.log(context.state.username)
    // console.log(context.state.admins)
    // console.log(context.state.admins.includes(context.state.admins))
    if (context.state.admins.includes(context.state.username)) {
      // console.log('I am an admin, ok to disable other user.')
      const params = {
        UserPoolId: config.poolData.UserPoolId,
        Username: uid /* required */
      }
      cognitoServiceProvider.adminDisableUser(params, function (err, data) {
        if (err) {
          console.log(err, err.stack)
        } else {
          console.log(`User ${uid} has been disabled.`)
          context.dispatch('fetchUsersFromCognito')
        }
      })
    } else {
      console.log('You are not allowed to disable user, please contact site administrator.')
    }
  },
  enableUser: (context, uid) => {
    if (uid === context.state.username) {
      return false
    }
    // check that i'm an admin.
    // console.log(context.state.username)
    // console.log(context.state.admins)
    // console.log(context.state.admins.includes(context.state.admins))
    if (context.state.admins.includes(context.state.username)) {
      // console.log('I am an admin, ok to enable other user.')
      const params = {
        UserPoolId: config.poolData.UserPoolId,
        Username: uid /* required */
      }
      cognitoServiceProvider.adminEnableUser(params, function (err, data) {
        if (err) {
          console.log(err, err.stack)
        } else {
          console.log(`User ${uid} has been enabled.`)
          context.dispatch('fetchUsersFromCognito')
        }
      })
    } else {
      console.log('You are not allowed to enable user, please contact site administrator.')
    }
  },
  updateProfile: (context, p) => {
    // console.log('updating user profile to: ')
    // console.log(p)
    var params = {
      UserAttributes: [
        {
          Name: 'profile',
          Value: p.profile
        }
      ],
      UserPoolId: config.poolData.UserPoolId,
      Username: p.username
    }
    if (context.state.admins.includes(context.state.username)) {
      cognitoServiceProvider.adminUpdateUserAttributes(params, function (err, data) {
        if (err) console.log(err, err.stack)
        else context.dispatch('fetchUsersFromCognito')
      })
    } else {
      console.log('You are not allowed to enable user, please contact site administrator.')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/authenticate.js